import {Col, Row} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {PageTitle} from '../../../_metronic/layout/core';
import PaymentAddressCard from './payment-address/PaymentAddressCard';
import Level3Title from '../../common/components/title/Level3Title';
import PaymentModeCard from './payment-mode/PaymentModeCard';
import MyBills from './MyBills';

const BillPage = (): JSX.Element => {
    const intl = useIntl();

    return (
        <>
            <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.MY_ACCOUNT'})}</PageTitle>
            <MyBills />
            <Row className='mt-5'>
                <Col md={6}>
                    <PaymentAddressCard />
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title m-0">
                                <Level3Title title={intl.formatMessage({id: 'BILLS.PAYMENT_DETAILS'})} />
                            </div>
                        </div>
                        <div className="card-body p-9"></div>
                    </div>
                </Col>
                <Col md={6}>
                    <PaymentModeCard />
                </Col>
            </Row>
        </>
    );
};

export default BillPage;
